import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/logo-title.svg';
const _withScopeId = n => (_pushScopeId("data-v-cd20c6bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-title"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "vector",
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("span", {
  class: "vector-text2"
}, " 软件开放平台 ")], -1));
const _hoisted_3 = {
  class: "login-body"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "body-text1"
}, "腾讯电脑管家"), /*#__PURE__*/_createElementVNode("div", {
  class: "body-text2"
}, "软件开放平台"), /*#__PURE__*/_createElementVNode("div", {
  class: "body-text3"
}, [/*#__PURE__*/_createElementVNode("p", null, " 平台目前支持腾讯电脑管家-软件管理中收录软件的上架/更新/下架等申请服务，并会陆续推出更多软件开放工具，尽请期待 ")])], -1));
const _hoisted_5 = {
  class: "image-content"
};
const _hoisted_6 = {
  key: 0,
  class: "login-content-unlogined"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top-text1"
}, "欢迎登录"), /*#__PURE__*/_createElementVNode("div", {
  class: "content-top-text2"
}, "请扫码确认身份")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-center"
}, null, -1));
const _hoisted_9 = {
  class: "content-bottom"
};
const _hoisted_10 = {
  class: "content-bottom-text1"
};
const _hoisted_11 = {
  class: "content-bottom-text2"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-bottom-text3"
}, " 并同意授权平台使用您的QQ头像、昵称信息 ", -1));
const _hoisted_13 = {
  key: 1,
  class: "login-content-iframe"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top-text1"
}, "欢迎登录"), /*#__PURE__*/_createElementVNode("div", {
  class: "content-top-text2"
}, "请使用QQ登录确认身份")], -1));
const _hoisted_15 = {
  class: "login-container"
};
const _hoisted_16 = {
  class: "loginall-body"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "50px"
  }
}, null, -1));
const _hoisted_18 = {
  style: {
    "width": "360px",
    "height": "255px",
    "overflow": "hidden",
    "border": "0px",
    "margin": "0 auto",
    "padding-top": "40px"
  }
};
const _hoisted_19 = {
  style: {
    "width": "500px",
    "height": "800px",
    "margin": "-103px 0px 0px -95px"
  }
};
const _hoisted_20 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_link = _resolveComponent("t-link");
  const _component_t_button = _resolveComponent("t-button");
  const _component_t_footer = _resolveComponent("t-footer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [!_ctx.data.isAgree ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createTextVNode(" 请阅读并同意"), _createVNode(_component_t_link, {
    theme: "primary",
    hover: "color",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.linkClick('item2'))
  }, {
    default: _withCtx(() => [_createTextVNode("《腾讯电脑管家软件开放平台开发者协议 》 ")]),
    _: 1
  })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_t_link, {
    theme: "primary",
    hover: "color",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.linkClick('item1'))
  }, {
    default: _withCtx(() => [_createTextVNode("《腾讯电脑管家隐私协议》")]),
    _: 1
  }), _createVNode(_component_t_link, {
    theme: "primary",
    hover: "color",
    href: "https://ti.qq.com/agreement/index.html",
    target: "_blank"
  }, {
    default: _withCtx(() => [_createTextVNode("《QQ软件许可协议》")]),
    _: 1
  })]), _hoisted_12, _createVNode(_component_t_button, {
    class: "content-bottom-botton",
    onClick: _ctx.agree,
    style: {
      "height": "45px",
      "width": "200px"
    },
    theme: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(" 同意协议，下一步")]),
    _: 1
  }, 8, ["onClick"])])])) : _ctx.data.isAgree ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("iframe", {
    id: "qq_login_frame",
    src: _ctx.iframeSrc,
    width: "800",
    height: "600",
    scrolling: "no"
  }, "\n                    ", 8, _hoisted_20)])])])])])])) : _createCommentVNode("", true)])]), _createVNode(_component_t_footer, {
    style: {
      "height": "18px",
      "padding": "0"
    },
    class: "choose-footer"
  }, {
    default: _withCtx(() => [_createVNode(_component_t_link, {
      style: 'color: #2049EE;',
      hover: "color",
      onClick: _ctx.goContactus
    }, {
      default: _withCtx(() => [_createTextVNode("联系我们 ")]),
      _: 1
    }, 8, ["onClick"]), _createTextVNode(" Copyright © 1998 - 2023 Tencent. All Rights Reserved. 腾讯公司 版权所有 ")]),
    _: 1
  })]);
}